import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getUserNeedsProfileSetupFromToken } from 'api';

const PrivateRoute = ({ children, ...rest }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  let { to } = location.state || { to: { pathname: '/prisijungimas' } };

  useEffect(() => {
    if (!token) {
      navigate('/prisijungimas', { state: { to: location } });
      return;
    }

    // Check if user needs to complete profile setup
    const needsProfileSetup = getUserNeedsProfileSetupFromToken(token);
    const isOnEditProfilePage = location.pathname === '/redaguoti-profili';

    // Redirect to edit profile if setup needed and not already there
    if (needsProfileSetup && !isOnEditProfilePage) {
      navigate('/redaguoti-profili', {
        state: { needsProfileSetup: true },
        replace: true,
      });
    }
  }, [navigate, token, location.pathname]);

  if (!token) {
    return null;
  }

  return <>{children}</>;
};

export default PrivateRoute;
